import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import CustomTabs from "pages/_components/CustomTabs/CustomTabs";
import * as i18n from "util/i18n";

import { selectors as sessionSelectors } from "reducers/session";

import Deposits from "./Deposits";
import Fci from "./Fci";
import Bac from "./Bac";
import Summary from "./Summary";

const DEFAULT_DOLLAR_RATE = 350;

// Tabs originales: clave I18N y textType
const tabsData = [
    { text: "investmentFunds.dashboard.tabs.pesos", textType: "I18N" },
    { text: "investmentFunds.dashboard.tabs.dollars", textType: "I18N" },
];

const DashboardTabs = ({ isDesktop, dollarRate }) => (
    <>
        <CustomTabs tabsData={tabsData} defaultTab={0}>
            {/* Tab 0: Pesos */}
            <div
                className="dashboard-tabs__row"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 32,
                    alignItems: "stretch",
                    flexWrap: "nowrap",
                }}>
                <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: 24 }}>
                        <Deposits currency="ARS" dollarRate={dollarRate} />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <Fci currency="ARS" dollarRate={dollarRate} />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <Bac currency="ARS" dollarRate={dollarRate} />
                    </div>
                </div>

                <div className="dashboard-tabs__summary" style={{ width: 300, minWidth: 260 }}>
                    <Summary currency="ARS" dollarRate={dollarRate} isDesktop={isDesktop} />
                </div>
            </div>

            {/* Tab 1: Dólares */}
            <div
                className="dashboard-tabs__row"
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    gap: 32,
                    alignItems: "stretch",
                    flexWrap: "nowrap",
                }}>
                <div style={{ flex: 1 }}>
                    <div style={{ marginBottom: 24 }}>
                        <Deposits currency="USD" dollarRate={dollarRate} />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <Fci currency="USD" dollarRate={dollarRate} />
                    </div>
                    <div style={{ marginBottom: 24 }}>
                        <Bac currency="USD" dollarRate={dollarRate} />
                    </div>
                </div>

                <div className="dashboard-tabs__summary" style={{ width: 300, minWidth: 260 }}>
                    <Summary currency="USD" dollarRate={dollarRate} isDesktop={isDesktop} />
                </div>
            </div>
        </CustomTabs>

        {/* Footer con advertencia de montos */}
        <div className="dashboard-footer">
            <small className="dashboard-footer__note">
                {i18n.get(
                    "investmentFunds.dashboard.amountWarning",
                    "*Los precios indicados corresponden al último valor de cierre de " +
                        "mercado o al último día hábil de negociación disponible.",
                )}
            </small>
        </div>
    </>
);

DashboardTabs.propTypes = {
    isDesktop: PropTypes.bool.isRequired,
    dollarRate: PropTypes.number.isRequired,
};

DashboardTabs.defaultProps = {
    // nada por ahora
};

const mapStateToProps = (state) => {
    const dollarRate =
        typeof sessionSelectors.getDolarRate === "function"
            ? sessionSelectors.getDolarRate(state)
            : DEFAULT_DOLLAR_RATE;

    return {
        isDesktop: state.media?.isDesktop ?? false,
        dollarRate,
    };
};

export default connect(mapStateToProps)(DashboardTabs);
